import _qs from 'query-string';

const stringify = (params: any) => _qs.stringify(params)

const qs = {
  stringify,
}

export default qs;
